import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import * as fromRoot from '../../../../../../state/app.state';
import { ConfirmDialogComponent, ConfirmDialogModel } from '../../../../../../shared/components';
import { ProjectsService } from '../../../../core/projects.service';

@Component({
  selector: 'app-claims-summary',
  templateUrl: './claims-summary.component.html',
  styleUrls: ['./claims-summary.component.scss'],
  standalone: false,
})
export class ClaimsSummaryComponent implements OnInit, OnDestroy {
  @Input() data: any;
  @Input() projectId = '';

  private readonly onDestroy: Subject<any> = new Subject<any>();

  constructor(
    private router: Router,
    private store: Store<fromRoot.State>,
    private dialog: MatDialog,
    private projectsService: ProjectsService,
  ) {}

  ngOnInit(): void {}

  redirectToProjectClaims(): void {
    const isFormDirty = this.projectsService.isAnyFormDirty.getValue();
    const doCloseAndNavigate = () => {
      this.projectsService.isAnyFormDirty.next(false);
      this.projectsService.closeRightPanel.next();
      this.router.navigate([`/projects/${this.projectId}`], {
        queryParams: { tab: 'warranty', subTab: 'claims' },
      });
    };
    if (!isFormDirty) {
      doCloseAndNavigate();
      return;
    }
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      disableClose: true,
      data: new ConfirmDialogModel(
        'Unsaved changes',
        'There are unsaved changes.<br/>Are you sure you want to discard?',
      ),
    });
    dialogRef.afterClosed().subscribe((result: boolean) => {
      if (result) {
        doCloseAndNavigate();
      }
    });
  }

  ngOnDestroy() {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }
}
